import Vue from 'vue'

// import RangePopover from './components/RangePopover'
import DatePickerPopover from './DatePickerPopover'
import StepperPopover from './StepperPopover'
import SingleStepperPopover from './SingleStepperPopover'
import SelectPopover from './SelectPopover'
import ListPopover from './ListPopover'
import OperatorPopover from './OperatorPopover'
import attributeTypes from '@/appComponents/workbench/attributePanel/services/attributeType'
import PopoverBox from './PopoverBox'
import RangeSlider from './RangeSlider'
import RangeSelectPopover from './RangeSelectPopover'
import PopoverFactory from './factory'
import InputFormPopover from './forms/InputFormPopover'

function choosePopover ({attribute, type}) {
  if (type === popoverTypes.ATTRIBUTE) {
    if (attribute.type === attributeTypes.SELECT) return SelectPopover
    if (attribute.type === attributeTypes.RANGE) {
      if (attribute.unit === 'int') {
        return StepperPopover
      } else if (attribute.unit === 'date') {
        return DatePickerPopover
      }
    }
    if (attribute.type === attributeTypes.RANGE_SELECT) {
      return RangeSelectPopover
    }
  } else if (type === popoverTypes.OPERATOR) {
    return OperatorPopover
  } else if (type === popoverTypes.TEXTLIST) {
    return ListPopover
  } else if (type === popoverTypes.COUNT_GROUP) {
    return SingleStepperPopover
  }
  throw new Error(`${type} is not a valid Popover type.`)
}

const createPopover = function ({direction, attribute, parent, type, list, align = 'center'}) {
  let el = document.createElement('div')
  el.style.overflow = 'hidden'
  document.body.appendChild(el)

  const Popover = Vue.extend(choosePopover({
    attribute, type, list
  }))

  const popoverBox = new Popover({
    el: el,
    propsData: {
      direction,
      attribute,
      list,
      parent,
      type,
      align
    }
  })

  return popoverBox
}

const createListPopover = function ({direction, parent, type, list, align = 'center', options}) {
  let el = document.createElement('div')
  el.style.overflow = 'hidden'
  document.body.appendChild(el)

  let Popover = Vue.extend(ListPopover)
  const popoverBox = new Popover({
    el: el,
    propsData: {
      direction,
      list,
      parent,
      type,
      align,
      options
    }
  })

  return popoverBox
}

export const popoverTypes = {
  ATTRIBUTE: 'ATTRIBUTE',
  TEXTLIST: 'TEXTLIST',
  OPERATOR: 'OPERATOR',
  COUNT_GROUP: 'COUNT_GROUP'
}

const Forms = {
  InputForm: InputFormPopover
}

export {
  createPopover,
  RangeSlider,
  PopoverBox,
  createListPopover,
  PopoverFactory,
  Forms
}



// WEBPACK FOOTER //
// ./src/app/components/common/popover/index.js